import React from 'react';

type Props = {
  page: number;
  limit: number;
  total: number;
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
};

const PaginationBar: React.FC<Props> = ({ page, limit, total, hasPrev, hasNext, onPrev, onNext }) => {
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <div className="px-6 py-4 border-t border-[#F4F4F4] flex items-center justify-between">
      <div className="text-sm text-gray-600">
        {total > 0 ? (
          <span>Showing {start}-{end} of {total} results</span>
        ) : (
          <span>No records</span>
        )}
      </div>
      <div className="flex items-center gap-2">
        <button onClick={onPrev} disabled={!hasPrev} className="px-3 py-1 text-sm border rounded-md disabled:opacity-50">Previous</button>
        <div className="text-sm text-gray-600">Page {page}</div>
        <button onClick={onNext} disabled={!hasNext} className="px-3 py-1 text-sm border rounded-md disabled:opacity-50">Next</button>
      </div>
    </div>
  );
};

export default React.memo(PaginationBar);
